import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createTheme, CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { useMemo } from "react";
import { atlasThemeOptions } from "../../themes/atlas/index.js";
const reducedMotionSettings = {
    transitions: { create: () => "none" },
};
export default function AtlasThemeProvider({ children, baseTheme, themeExtension, themeOptions = atlasThemeOptions, locales = [], useCssBaseline = true, }) {
    if (!themeOptions && !baseTheme && !themeExtension) {
        throw new Error("AtlasThemeProvider: You must provide either `themeOptions` or `baseTheme` or `themeExtension`.");
    }
    if (process.env.NODE_ENV !== "production" && baseTheme) {
        console.warn("AtlasThemeProvider: The `baseTheme` prop is deprecated. Use `themeOptions` instead.");
    }
    if (process.env.NODE_ENV !== "production" && themeExtension) {
        console.warn("AtlasThemeProvider: The `themeExtension` prop is deprecated. Use `themeOptions` instead.");
    }
    const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
    const theme = useMemo(() => {
        const themeObj = createTheme(themeOptions, prefersReducedMotion ? reducedMotionSettings : {}, ...locales, {
            // As MUI would evaluate all tokens here, and we have getters handling fallback values
            // we will first create a theme without tokens, and then add them after the fact.
            tokens: undefined,
        });
        themeObj.tokens = themeOptions.tokens;
        return themeObj;
    }, [locales, themeOptions, prefersReducedMotion]);
    return (_jsxs(ThemeProvider, Object.assign({ theme: theme }, { children: [useCssBaseline && _jsx(CssBaseline, {}), children] })));
}
//# sourceMappingURL=AtlasThemeProvider.js.map